import React from 'react';
import PropTypes from 'prop-types';
import {
  FDContentContainer,
  FDDialog,
  FDDialogContent,
  FDDialogTitle,
} from '@facet-wealth/design';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import fr from 'facet-rest';
import { useRefreshActionItem } from 'Hooks/useRefreshEvent';
import DialogContent from './DialogContent';

export default function GroupedTasksDialog({
  open,
  handleClose,
  relationship,
  showHidden,
  setShowHidden,
}) {
  const [link, setLink] = React.useState(relationship?.link('related'));

  const {
    collection,
    isInitializing,
    loadingError,
  } = useLink(link);

  const refresh = React.useCallback(() => {
    if (!collection) return;
    const queryName = showHidden ? fr.queries.householdHiddenTasks.name : fr.queries.householdActiveTasks.name;

    collection.query(queryName, (l) => {
      setLink(l);
    });
  }, [collection, showHidden]);

  React.useEffect(() => {
    refresh();
  }, [showHidden]);

  useRefreshActionItem(() => {
    refresh();
  }, [refresh]);

  return (
    <FDDialog
      fullScreen
      open={open}
      onClose={handleClose}
    >
      <FDDialogTitle value={'My Actions'} />
      <FDDialogContent>
        <FDContentContainer maxWidth="xl">
          <DataContainer
            component={DialogContent}
            loading={isInitializing}
            loadingError={loadingError}
            componentProps={{
              collection,
              showHidden,
              setShowHidden,
              refresh,
            }}
          />
        </FDContentContainer>
      </FDDialogContent>
    </FDDialog>
  );
}

GroupedTasksDialog.defaultProps = {};

GroupedTasksDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  relationship: PropTypes.object.isRequired,
  showHidden: PropTypes.bool.isRequired,
  setShowHidden: PropTypes.func.isRequired,
};
